export default __webpack_public_path__ + "media/components/AdEdit/images/instagram-bookmark-f5edad32ab803c4955e7b4f2feb0faee.png";